const UUID_RE = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
// Используется с флагом 'i' в регулярных выражениях
const SLUG_RE = '[a-z0-9][a-z0-9-]*';
/**
 * Правила для замены slug в URL на параметр `:slug`.
 * Применяются перед общей заменой UUID.
 */
const PATH_RULES = [
    {
        name: 'community-slug',
        // Универсальный паттерн для любых подпунктов community
        pattern: new RegExp(`^(\\/community\\/${UUID_RE})\\/(${SLUG_RE})(\\/.*)?$`, 'i'),
        replace: (match, prefix, slug, tail) => `${prefix}/:slug${tail || ''}`,
    },
];
/**
 * Нормализует имя транзакции для Sentry, заменяя динамические сегменты на параметры.
 *
 * Выполняет замену в два этапа:
 * 1. Применяет PATH_RULES для замены slug на `:slug`
 * 2. Заменяет все UUID на `:id`
 *
 * @param name - Имя транзакции (URL путь).
 * @returns Нормализованное имя с параметрами вместо динамических значений.
 *
 * @example
 * normalizeTransactionName('/community/abc123-def456/slug-name/manage')
 * // → '/community/:id/:slug/manage'
 * @example
 * normalizeTransactionName('/users/abc123-def456-7890-abcd-ef1234567890/profile')
 * // → '/users/:id/profile'
 */
export const normalizeTransactionName = (name) => {
    if (!name || typeof name !== 'string') {
        return name;
    }
    let result = name;
    for (const rule of PATH_RULES) {
        result = result.replace(rule.pattern, rule.replace);
    }
    result = result.replace(new RegExp(UUID_RE, 'gi'), ':id');
    return result;
};
